module.exports = __webpack_public_path__ + "static/media/add category.a40973f4.svg";